import React from "react";

const ProjelerPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">
    {/* Hero */}
    <div className="bg-gradient-to-br from-[#0F172A] to-brand-bordo-dark py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Faaliyetler
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Projeler</h1>
        <p className="text-white/70 max-w-xl mx-auto">
          Derneğimizin hemşehrilerimiz ve geleceğimiz için yürüttüğü projeler.
        </p>
      </div>
    </div>
  </div>
);

export default ProjelerPage;
